var VehicleEditModal = (function (base) {
  __extends(VehicleEditModal, base);


  function VehicleEditModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };


  VehicleEditModal.prototype.activate = function (vehicleId) {
    const self = this;
    var isNew = !vehicleId;
    const url = isNew ? `api/vehicles/add` : `api/vehicles/${vehicleId}/edit`;
    var $form;

    function init($modal, vehicleId) {
        $form = $('form', $modal);
        FormHelper.init($form, isNew ? 'PUT' : 'POST', 'api/vehicles');
          if (vehicleId)
            VehicleHistory.Init($modal, vehicleId, false);
    }

    this.loadContent(url)
      .then($modal => {

        init($modal, vehicleId);
            $modal
                //Кнопка `Сохранить`
                .on('click',
                    '[js=save]',
                    function() {
                        $modal.busy();
                        $form.send()
                            .then((id) => {
                                if (isNew) {
                                    self.reloadContent(`api/vehicles/${id}/edit`)
                                        .then(() => {
                                            isNew = false;
                                            init($modal, id);
                                            $('.nav-tabs a[href=#tracker-history-edit]').tab('show');
                                        });
                                } else {
                                    self.close({ ok: true });
                                }
                            })
                            .catch(() => $modal.busy(false));
                    })
                .on('change',
                    '[js="contractor-selector"]',
                function (e) {
                    var contractorId = $(this).val();
                    var $rep = $('[js="representative-vehicle"]');
                    $rep.find('option').each(function() {
                        var contractorsRaw = $(this).attr('data-contractors');
                        var contractors = contractorsRaw.split(',');
                        if ($.inArray(contractorId, contractors) !== -1) {
                            $(this).attr('disabled', 'disabled');
                            $(this).removeAttr('selected');
                        } else {
                            $(this).removeAttr('disabled');
                        }
                    });

                    $('.select2', $modal).select2("destroy").select2({
                                placeholder: 'Данные отсутствуют'
                            });
              });
            if (isNew)
                $('[js="contractor-selector"]').change();
            else 
                $('.select2', $modal).select2({ placeholder: 'Данные отсутствуют' });
          });

  };


  return VehicleEditModal;
}(BaseModal));
